import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3";
import { throwReadableError } from "Utilities/fnReportError";

const setNetworkPhoto = async (payload, options) => {
  const endpoint = `/upload/photo/group`;

  const fetchFunction = new FnrFetch3(endpoint, payload, options);

  const response = await fetchFunction
    .post()
    .catch((err) => throwReadableError(endpoint, err));

  return response;
};

export { setNetworkPhoto };
